import ReferenceMemberTags from '@modules/apiReference/page/sharedUI/components/ReferenceMemberTags';
import { CloudTag } from '@modules/ui/tags/types';
import { EVisibility } from '@rbx/docsite-utilities/dist/browser';
import { Typography, TTypographyProps } from '@rbx/ui';
import React, { FunctionComponent } from 'react';
import useEndpointStyles from './CloudV2Endpoint.styles';

export interface EndpointTitleProps {
  title: string;
  visibility?: string;
  operationId: string;
  headingVariant?: TTypographyProps['variant'];
}

const EndpointTitle: FunctionComponent<React.PropsWithChildren<EndpointTitleProps>> = ({
  title,
  visibility,
  operationId,
  headingVariant = 'h2',
}) => {
  const { classes } = useEndpointStyles();

  return (
    <Typography variant={headingVariant} component={headingVariant} id={operationId} paddingTop={4}>
      {title}
      {visibility === EVisibility.Beta && (
        <ReferenceMemberTags
          className={classes.tags}
          tags={[CloudTag.Beta]}
          referenceClass='cloud'
        />
      )}
    </Typography>
  );
};

export default EndpointTitle;
